import { Component, OnInit } from '@angular/core';
import { DepartmentBase } from '../department.base';

@Component({
  selector: 'dpto-20',
  templateUrl: './dpto20.component.html',
  styleUrls: ['../department/department.component.css']
})
export class Dpto20Component extends DepartmentBase {
  municipalities = [{
    "id": 404,
    "code": "20001",
    "name": "Valledupar",
    "state": "1",
    "department_code": "20"
  }, {
    "id": 405,
    "code": "20011",
    "name": "Aguachica",
    "state": "1",
    "department_code": "20"
  }, {
    "id": 406,
    "code": "20013",
    "name": "Agust\u00edn Codazzi",
    "state": "1",
    "department_code": "20"
  }, {
    "id": 407,
    "code": "20032",
    "name": "Astrea",
    "state": "1",
    "department_code": "20"
  }, {
    "id": 408,
    "code": "20045",
    "name": "Becerril",
    "state": "1",
    "department_code": "20"
  }, {
    "id": 409,
    "code": "20060",
    "name": "Bosconia",
    "state": "1",
    "department_code": "20"
  }, {
    "id": 410,
    "code": "20175",
    "name": "Chimichagua",
    "state": "1",
    "department_code": "20"
  }, {
    "id": 411,
    "code": "20178",
    "name": "Chiriguan\u00e1",
    "state": "1",
    "department_code": "20"
  }, {
    "id": 412,
    "code": "20228",
    "name": "Curuman\u00ed",
    "state": "1",
    "department_code": "20"
  }, {
    "id": 413,
    "code": "20238",
    "name": "El Copey",
    "state": "1",
    "department_code": "20"
  }, {
    "id": 414,
    "code": "20250",
    "name": "El Paso",
    "state": "1",
    "department_code": "20"
  }, {
    "id": 415,
    "code": "20295",
    "name": "Gamarra",
    "state": "1",
    "department_code": "20"
  }, {
    "id": 416,
    "code": "20310",
    "name": "Gonz\u00e1lez",
    "state": "1",
    "department_code": "20"
  }, {
    "id": 417,
    "code": "20383",
    "name": "La Gloria",
    "state": "1",
    "department_code": "20"
  }, {
    "id": 418,
    "code": "20400",
    "name": "La Jagua de Ibirico",
    "state": "1",
    "department_code": "20"
  }, {
    "id": 419,
    "code": "20443",
    "name": "Manaure",
    "state": "1",
    "department_code": "20"
  }, {
    "id": 420,
    "code": "20517",
    "name": "Pailitas",
    "state": "1",
    "department_code": "20"
  }, {
    "id": 421,
    "code": "20550",
    "name": "Pelaya",
    "state": "1",
    "department_code": "20"
  }, {
    "id": 422,
    "code": "20570",
    "name": "Pueblo Bello",
    "state": "1",
    "department_code": "20"
  }, {
    "id": 423,
    "code": "20614",
    "name": "R\u00edo de Oro",
    "state": "1",
    "department_code": "20"
  }, {
    "id": 424,
    "code": "20621",
    "name": "La Paz",
    "state": "1",
    "department_code": "20"
  }, {
    "id": 425,
    "code": "20710",
    "name": "San Alberto",
    "state": "1",
    "department_code": "20"
  }, {
    "id": 426,
    "code": "20750",
    "name": "San Diego",
    "state": "1",
    "department_code": "20"
  }, {
    "id": 427,
    "code": "20770",
    "name": "San Mart\u00edn",
    "state": "1",
    "department_code": "20"
  }, {
    "id": 428,
    "code": "20787",
    "name": "Tamalameque",
    "state": "1",
    "department_code": "20"
  }]
}
